<template>
  <div v-if="!job.length && !this.loader" class="job column">
    <div class="title row column-s">
      <div class="title grid-1-g grid-2-m grid-12-s row">
        Job &nbsp;
        <strong>{{ job.id }}</strong>
      </div>
      <div class="grid-11 row align-center justify-end-g justify-end-m">
        <Button layout="gold" @click="openNote">
          <img src="../assets/img/writing.svg" /> Anotações </Button
        >&nbsp;
        <Button
          layout="gray"
          @click="openAttendance"
          v-if="job.status_atendimento || job.status == 'Rescindido'"
        >
          <img src="../assets/img/list.svg" /> Lista de Atendimentos
        </Button>

        <!-- <div class="status row justify-end grid-6-g grid-7-m hide-s">
          <Button layout="red-go">Reabrir job</Button>
        </div>-->
      </div>
    </div>
    <div class="info row label align-center wrap justify-space">
      <div class="grid-6-s grid-1-g">
        Status
        <br />
        <strong>{{ job.status_cliente.replace("Doutor", "Supporter") }}</strong>
      </div>
      <div class="grid-6-s grid-1-g">
        Atendimento
        <br />
        <strong>{{ job.forma_atendimento }}</strong>
      </div>
      <div class="grid-6-s grid-2-g">
        Abertura
        <br />
        <strong>{{ new Date(job.criado_em).toLocaleString() }}</strong>
      </div>
      <div class="grid-6-s grid-2-g">
        Agendado para
        <br />
        <strong>{{ new Date(job.dh_agendamento_cliente).toLocaleString() }}</strong>
      </div>
      <div class="grid-6-s grid-2-g" v-if="job.codigo_chamado_cliente">
        Código Cliente
        <br />
        <strong>{{ job.codigo_chamado_cliente }}</strong>
      </div>
      <div class="grid-6-s grid-2-g" v-if="job.cliente_cliente">
        Cliente
        <br />
        <strong>{{ job.cliente_cliente }}</strong>
      </div>
    </div>
    <div class="info column label" v-if="job.id_atendimento_atual">
      <div class="sla">Supporter</div>
      <div class="row wrap justify-space label align-center">
        <!--   <div class="grid-12-s grid-4-g grid-4-m">
          <AvatarSupporter :job="job" /><br />
        </div> -->

        <div
          class="grid-12-s grid-4-m grid-2-g row perfil align-center justify-center-s margin-bottom"
        >
          <div>
            <img
              :src="job.foto_agregado_doutor || job.foto_doutor"
              v-if="job.foto_agregado_doutor || job.foto_doutor"
            />
            <img src="../assets/img/usuario_padrao.png" v-else />
          </div>
          <div>
            Nome
            <br />
            <strong>{{ job.nome_agregado_doutor || job.nome_doutor }}</strong>
          </div>
        </div>

        <div class="grid-12-s grid-8-m grid-3-g comp">
          Competências
          <br />
          <strong v-if="job.competencias_agregado_doutor">{{
            job.competencias_agregado_doutor
              ? job.competencias_agregado_doutor.join(", ")
              : ""
          }}</strong>
          <strong v-else>{{
            job.competencias_doutor ? job.competencias_doutor.join(", ") : ""
          }}</strong>
        </div>
        <div class="grid-6-m grid-1-g grid-6-s justify-center margin-bottom">
          Score
          <br />
          <strong class="font-18 text-green" v-if="job.score_agregado_doutor">
            {{
              job.score_agregado_doutor
                ? job.score_agregado_doutor.toString().replace(".", ",")
                : "5,00"
            }}</strong
          >
          <strong class="font-18 text-green" v-else>
            {{ job.score ? job.score.toString().replace(".", ",") : "5,00" }}</strong
          >
        </div>
        <div class="grid-6-m grid-1-g grid-6-s justify-center margin-bottom">
          Atendimentos:
          <br />
          <strong class="font-18 text-green">
            {{ job.atendimentos_agregado_doutor || job.atendimentos_doutor }}</strong
          >
        </div>
        <div class="grid-6-m grid-1-g grid-6-s justify-center margin-bottom">
          Cadastrado em:
          <br />
          <strong class="font-18 text-green" v-if="job.cadastro_agregado_doutor">
            {{ job.cadastro_doutor | date }}</strong
          >
          <strong class="font-18 text-green" v-else>
            {{ job.cadastro_doutor | date }}</strong
          >
        </div>

        <!-- <div class="grid-6-s grid-1-g">
          ID - Supporter
          <br />
          <strong>{{ job.id_doutor }} - {{ job.nome_doutor }}</strong>
        </div> -->

        <div class="grid-6 grid-1-g margin-bottom" v-if="user.perfil !== 'cliente'">
          Celular
          <br />
          <strong>{{ job.celular_doutor | phone }}</strong>
        </div>
        <div class="grid-6-s grid-6-m grid-1-g margin-bottom">
          RG
          <br />
          <strong>{{ job.rg_agregado_doutor || job.rg_doutor }}</strong>
        </div>
        <div
          class="grid-6-m grid-6-s grid-1-g margin-bottom"
          v-if="user.perfil == 'funcionario'"
        >
          Gestor da Demanda
          <br />
          <strong>{{ job.nome_gestor }}</strong>
        </div>
        <div
          class="grid-6-m grid-12-s grid-2-g margin-bottom"
          v-if="user.perfil !== 'cliente'"
        >
          E-mail
          <br />
          <strong>{{ job.email_doutor }}</strong>
        </div>
      </div>
    </div>
    <div class="data column label">
      <div class="sla">SLA | Eventos</div>
      <div class="row wrap-s">
        <div v-if="job.forma_atendimento != 'remoto'" class="grid-3 grid-6-s">
          Início Deslocamento
          <br />
          <div class="sla-content row align-center">
            <JobStatus
              v-if="job.sla_inicio_deslocamento"
              :color="
                (job.dh_inicio_deslocamento &&
                  new Date(job.sla_inicio_deslocamento) >
                    new Date(job.dh_inicio_deslocamento)) ||
                new Date(job.sla_inicio_deslocamento) > new Date()
                  ? 'green'
                  : 'red'
              "
            />
            <div class="sla-status" v-if="job.sla_inicio_deslocamento">
              <strong>{{
                new Date(job.sla_inicio_deslocamento).toLocaleString()
              }}</strong>
              <br />
              <strong v-if="job.dh_inicio_deslocamento">{{
                new Date(job.dh_inicio_deslocamento).toLocaleString()
              }}</strong>
            </div>
          </div>
        </div>
        <div class="grid-3 grid-6-s">
          Check-in
          <br />
          <div class="sla-content row align-center">
            <JobStatus
              v-if="job.sla_checkin"
              :color="
                (job.dh_checkin &&
                  new Date(job.sla_checkin) > new Date(job.dh_checkin)) ||
                new Date(job.sla_checkin) > new Date()
                  ? 'green'
                  : 'red'
              "
            />
            <div class="sla-status" v-if="job.sla_checkin">
              <strong>{{ new Date(job.sla_checkin).toLocaleString() }}</strong>
              <br />
              <strong v-if="job.dh_checkin">{{
                new Date(job.dh_checkin).toLocaleString()
              }}</strong>
            </div>
          </div>
        </div>
        <div class="grid-3 grid-6-s">
          Fim Atendimento
          <br />
          <div class="sla-content row align-center">
            <JobStatus
              v-if="job.sla_encerramento"
              :color="
                (job.dh_fechamento &&
                  new Date(job.sla_encerramento) >
                    new Date(job.dh_fechamento) >=
                    new Date()) ||
                new Date(job.sla_encerramento) > new Date()
                  ? 'green'
                  : 'red'
              "
            />
            <div class="sla-status" v-if="job.sla_encerramento">
              <strong>{{ new Date(job.sla_encerramento).toLocaleString() }}</strong>
              <br />
              <strong v-if="job.dh_encerramento">{{
                new Date(job.dh_encerramento).toLocaleString()
              }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="job.forma_atendimento != 'remoto'" class="data column label">
      <div class="sla">Local de atendimento</div>
      <div class="row column-s">
        <div class="grid-2-g grid-3-m">
          Endereço
          <br />
          <strong>{{ job.logradouro }}, {{ job.numero }}</strong>
        </div>
        <div class="grid-2-g grid-3-m">
          Complemento
          <br />
          <strong>{{ job.complemento }}</strong>
        </div>
        <div class="grid-2-g grid-3-m">
          Bairro
          <br />
          <strong>{{ job.bairro }}</strong>
        </div>
        <div class="grid-2-g grid-3-m">
          Cidade/Estado
          <br />
          <strong>{{ job.cidade }}/{{ job.estado }}</strong>
        </div>
        <div class="grid-2-g grid-3-m">
          CEP
          <br />
          <strong>{{ job.cep | cep }}</strong>
        </div>
      </div>
    </div>

    <div class="grid-12 column label">
      <div class="row column-s problem">
        <div class="grid-6 grid-12-s column label">
          <label>
            Descrição Problema
            <i class="fa fa-question-circle font-13 tip">
              <div>
                Descreva em detalhes o seu problema. Não informe aqui dados sensíveis.
              </div>
            </i>
          </label>
          <div v-html="job.problema.replace(/\n/g, '<br />')"></div>
        </div>
        <div class="grid-6 grid-12-s column label" v-if="escopo.length">
          <label>
            Complementos
            <i class="fa fa-question-circle font-13 tip">
              <div>Complementos de escopo.</div>
            </i>
          </label>
          <div style="margin-top: 12px" v-for="(e, i) of escopo" :key="i"><i style="font-size: 11px">{{ e.criado_em | date }} - {{ e.nome_criado_por }}:</i><br>{{ e.nota }}</div>
        </div>
        <div class="grid-6 grid-12-s column label">
          <br />
          <label>
            Dados Sensíveis
            <i class="fa fa-question-circle font-13 tip">
              <div>
                Informe aqui dados sensíveis como contatos, endereços, senhas, nomes,
                telefones, etc.
              </div>
            </i>
          </label>
          <div v-if="job.dado_sensivel" v-html="job.dado_sensivel.replace(/\n/g, '<br />')"></div>
        </div>
      </div>
    </div>

    <Notes :notes="job.notas" />

    <div class="buttons-2 row column-s align-center">
      <div class="grid-4 grid-12-s hide-s">
        <Button layout="white-m-gray" @click="router.back()">
          <i class="fa fa-arrow-left"></i> Voltar
        </Button>
      </div>
    </div>
    <Modal :modal="modal" />
  </div>
  <div v-else class="job-loader column align-center justify-center">
    <Loader />
  </div>
</template>

<script>
import Loader from "@/components/Loader";
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";
import Modal from "@/components/Modal";
import JobStatus from "@/components/JobStatus";
import Notes from "@/components/Notes";
import Router from "@/router";

export default {
  name: "job",
  props: {
    id: String,
  },
  components: { Button, Loader, Modal, JobStatus, Notes },
  data() {
    return {
      loader: true,
      job: {},
      orientation: true,
      modal: {},
      router: Router,
      escopo: [],
    };
  },
  methods: {
    ...mapGetters("job", ["GET_JOB"]),
    ...mapActions("job", ["LOAD_JOB", "COMPLEMENTO_ESCOPO"]),
    update() {
      this.loader = false;
      this.modal.description += this.job.id;
      this.orientation = this.job.status != "Com Doutor" ? false : true;
      this.modal.callback =
        this.job.status != "Com Doutor" ? () => (this.modal.show = false) : this.oriented;
    },
    async getJob() {
      this.LOAD_JOB(this.$route.params.id).then(() => {
        this.job = this.GET_JOB();
        this.update();
      });
    },
    openNote() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Anotações",
        description: "Job J",
        layout: "Note",
      };
      this.update();
    },
    openAttendance() {
      this.modal = {
        id: this.id || this.$route.params.id,
        show: true,
        title: "Atendimentos",
        description: "Job J",
        layout: "Attendance",
      };
      this.update();
    },
    /*     reopen() {
      if (this.job.status != "Validado com sucesso" || this.job.dh_aceite_cliente == null) return false;
      let dh_aceite_cliente = Date.parse(this.job.dh_aceite_cliente);
      let agora = Date.now();
      if ((agora - this.job.dh_aceite_cliente) / 1000 / 60 / 60 > 72) return false;
      if (["Fechado", "Cancelado", "Rescindido"].indexOf(this..job.status) >= 0) return false
      
      return true;
    } */
  },
  beforeMount(){
    this.COMPLEMENTO_ESCOPO(this.id || this.$route.params.id).then(({ data }) => this.escopo = data)
  },
  mounted() {
    
    this.getJob();
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.job {
  padding: 32px 35px;
  box-shadow: $shadow;
  background: $white;
  border-radius: 23px;

  .title {
    @media (max-width: $large) {
      padding-bottom: 15px;
    }

    strong {
      color: $supporter-1;
    }
  }

  .buttons {
    @media (max-width: $small) {
      margin-top: 27px;
      margin-bottom: 10px;
    }
  }
  .buttons-2 {
    padding-top: 35px;
    @media (max-width: $small) {
      margin-top: 27px;
      margin-bottom: 10px;
      button {
        margin-bottom: 20px;
      }
    }
  }
  &-loader {
    margin-top: 20%;
  }
  .title {
    font-size: 26px;
    font-weight: 400;
  }
  .sla {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 30px;
    &-content {
      margin-top: 7px;
    }
    &-status {
      margin-left: 10px;
    }
  }
  .perfil {
    img {
      width: 85px;
      height: 85px;
      margin-right: 8px;
    }
  }
  .info {
    margin-top: 25px;
    padding-bottom: 34px;
    border-bottom: 1px solid $white-1;
  }
  .margin-bottom {
    @media (max-width: $large) {
      margin-bottom: 30px;
    }
  }
  .comp {
    @media (max-width: $large) {
      margin: 20px 0px;
    }
  }
  .status {
    color: $white-7;
    font-size: 12px;
    list-style: none;

    li {
      margin-left: 40px;
      @media (max-width: $medium) {
        margin-left: 10px;
      }
    }
    .active {
      color: $green-9;
      border-bottom: 2px solid $green-9;
      height: 30px;
      font-weight: bold;
    }
  }
  .label {
    color: $gray-6;
    font-size: 15px;
    font-weight: 300;
    strong {
      color: $gray-7;
      text-transform: capitalize;
    }
  }
  .data {
    padding-top: 45px;
    padding-bottom: 46px;
    border-bottom: 1px solid $white-1;
    label {
      margin-bottom: 8px;
    }
    .grid-2-g {
      @media (max-width: $small) {
        margin-bottom: 30px;
      }
    }
    .ps {
      color: $gray-6;
      background: $white-8;
      padding: 8px 14px;
      border-radius: 5px;
      margin-left: 30px;
    }
    .row-2 {
      margin-top: 32px;
    }
  }
  .openmap {
    @media (max-width: $medium) and (min-width: $small) {
      margin-top: 38px;
    }
    @media (max-width: $small) {
      margin-top: 38px;
      justify-content: center;
      button {
        width: 100%;
      }
    }

    @media (min-width: $small) and (max-width: $large) {
      margin-top: 25px;
      justify-content: flex-end;
    }
  }
  .button-green-go,
  .button-blue-go,
  .button-red-go {
    margin-left: 10.5px;
  }
  .button-black-go {
    display: flex;
    flex-direction: row;
    align-items: center;
    i {
      margin-right: 6px;
      font-size: 20px;
      transform: rotate(90deg);
    }
  }

  @media (max-width: $small) {
    .button-gold-2 {
      margin-top: 10px;
    }
  }
  .problem {
    margin-top: 21px;
  }
}
</style>
